<template>
	<div class="personal_info">
		<div class="title">钻石:</div>
		<div class="cash_box">
			<span class="text"><i></i>{{rmb | filterRange}}</span>
			<span class="add" @click="showBox"></span>
		</div>
		<div class="title elb">ELB:</div>
		<div class="elb_box">
			
			<span class="text"><i></i>{{elb | filterRange}}</span>
		</div>
		
		<!--充值提示-->
        <!--<rechargePrompt v-show = "showRechargePrompt" @colse = 'closeBox'></rechargePrompt>-->
	</div>
</template>

<script>
	import {rechargeParam} from '../assets/js/common.js'
//	import rechargePrompt from './recharge_prompt'
	
	export default{
		props:{
			info:{
				type:Object
			}
		},
		data(){
			return {
				elb:0,
				rmb:0,
//				showRechargePrompt:false,
			}
		},
		watch:{
			info:function(){
//				this.rmb = this.info.rmb.split(".")[0];
				this.rmb = this.info.rmb;
//				this.elb = this.info.elb.split(".")[0];
				this.elb = this.info.elb;
			}
		},
		created(){
		},
		methods:{
			showBox(){
				this.$emit("open");
			}
//			closeBox(){
//				this.showRechargePrompt = false;
//			}
		},
		filters:{
			filterRange:function(num) {
				return Number(num).toFixed(2);
		   	}
		},
		components:{
//			rechargePrompt
		}
	}
</script>

<style scoped="scoped">
	.personal_info{
		position: absolute;
		top: 0.35rem;
		left: 0;
	}
	.personal_info .title{
		margin-left: 0.3rem;
		display: inline-block;
		height: 0.4rem;
		line-height: 0.4rem;
		font-size:0.24rem;
		font-family:Source Han Sans SC;
		font-weight:400;
		color:rgba(28,28,32,1);
		vertical-align: middle;
	}
	.personal_info .title.elb{
		margin-left: 0.8rem;
	}
	.cash_box{
		position: relative;
		display: inline-block;
		vertical-align: middle;
		width: 1.4rem;
		height: 0.4rem;
		background: url(../assets/img/nationalDay/nationalCashBg.png) no-repeat center left;
		background-size: 1.35rem 0.31rem;
	}
	.cash_box .text,.elb_box .text{
		display: inline-block;
		/* text-align:center;
		width: 1.35rem;
		height: 0.31rem;
		line-height: 0.31rem;
		font-size:0.22rem;
		font-family:Source Han Sans SC;
		font-weight:400;
		color:rgba(51,51,51,1);
		background:linear-gradient(143deg,rgba(255,243,216,0.84),rgba(255,211,127,0.84));
		border-radius:16px;
		position:relative;
		display:flex;
		justify-content: space-between;
		align-items:center;
		padding-right:0.2rem;
		box-sizing: border-box; */
		margin-left: 0.4rem;
		width: 1rem;
		height: 0.44rem;
		line-height: 0.44rem;
		font-size:0.24rem;
		font-family:PingFangSC-Regular;
		color:rgba(33,33,33,1);
	}
	/* .cash_box .text i{
		display:inline-block;
		width:0.32rem;
		height:0.25rem;
		background:url("../assets/img/midAutum/diamonds.png")no-repeat;
		background-size:100% 100%;
		margin-left:0.09rem;
	}
	.elb_box .text i{
		display:inline-block;
		width:0.28rem;
		height:0.3rem;
		background:url("../assets/img/midAutum/elb.png")no-repeat;
		background-size:100% 100%;
		margin-left:0.14rem;
	} */
	.cash_box .add{
		position: absolute;
		right: -0.4rem;
		top: 0;
		width: 0.4rem;
		height: 0.4rem;
		background: url(../assets/img/nationalDay/nationalAddIcon.png) no-repeat center center;
		background-size: 0.23rem;
	}
	.elb_box{
		display: inline-block;
		width: 1.4rem;
		height: 0.4rem;
		background: url(../assets/img/nationalDay/nationalElbBg.png) no-repeat center left;
		background-size: 1.35rem 0.31rem;
		vertical-align: middle;
	}
</style>


// WEBPACK FOOTER //
// src/components/personal_info.vue